import React from 'react';
import { APP_STORE_URL } from '../utils/appLinks';
import './AppStoreBadge.css';

/**
 * "Download on the App Store" badge. Self-contained (black pill, works on any
 * background). Points at APP_STORE_URL from utils/appLinks.js — swap that one
 * constant for the real listing URL.
 */
const AppStoreBadge = ({ className = '', onClick }) => (
  <a
    href={APP_STORE_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`app-store-badge ${className}`.trim()}
    onClick={onClick}
    aria-label="Download Canira on the App Store"
  >
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.05 12.04c-.02-2.05 1.68-3.03 1.75-3.08-.95-1.39-2.43-1.58-2.96-1.6-1.26-.13-2.46.74-3.1.74-.64 0-1.62-.72-2.67-.7-1.37.02-2.64.8-3.35 2.03-1.43 2.48-.37 6.15 1.02 8.16.68.98 1.49 2.08 2.55 2.04 1.02-.04 1.41-.66 2.65-.66 1.23 0 1.59.66 2.67.64 1.1-.02 1.8-1 2.48-1.99.78-1.14 1.1-2.24 1.12-2.3-.02-.01-2.15-.83-2.18-3.28l-.25.01zM15.1 6.24c.56-.68.94-1.63.84-2.57-.81.03-1.79.54-2.37 1.22-.52.6-.98 1.56-.86 2.48.9.07 1.83-.46 2.39-1.13z" />
    </svg>
    <span className="app-store-badge-text">
      <small>Download on the</small>
      App Store
    </span>
  </a>
);

export default AppStoreBadge;
